import { combineReducers } from 'redux'

// ACTIONS
export const UPDATE_DETAIL_SUCCESS = 'company/candidateList/stickyFilters/UPDATE_DETAIL_SUCCESS'
export const UPDATE_CANDIDATE_COUNT = 'company/candidateList/stickyFilters/UPDATE_CANDIDATE_COUNT'

export const RESET_POSITION_DETAIL = 'company/candidateList/stickyFilters/RESET_POSITION_DETAIL'
export const RESET_POSITION_DETAIL_SUCCESS = 'company/candidateList/stickyFilters/RESET_POSITION_DETAIL_SUCCESS'

export const RESET_ALL = 'company/candidateList/stickyFilters/RESET_ALL'

export const TOGGLE_LOADING = 'company/candidateList/stickyFilters/TOGGLE_LOADING'
export const TOGGLE_RESET = 'company/candidateList/stickyFilters/TOGGLE_RESET'

// ACTION CREATORS
export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const toggleResetting = resetting => ({
  type: TOGGLE_RESET,
  payload: { resetting },
})

export const updateDetailSuccess = ({ result }) => ({
  type: UPDATE_DETAIL_SUCCESS,
  payload: {
    member: {
      ...result,
    },
  },
})

export const updateCandidateCounts = count => ({
  type: UPDATE_CANDIDATE_COUNT,
  payload: count,
})

export const resetPositionDetail = () => ({
  type: RESET_POSITION_DETAIL,
})

export const resetPositionDetailSuccess = name => ({
  type: RESET_POSITION_DETAIL_SUCCESS,
  payload: {
    name,
  },
})

export const resetAll = () => ({
  type: RESET_ALL,
})

// REDUCERS
const defaultUtils = {
  loading: true,
  resetting: false,
  error: null,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
    case TOGGLE_RESET:
      return {
        ...state,
        ...payload,
      }

    case RESET_ALL:
      return defaultUtils

    default:
      return state
  }
}

const defaultMember = {
  id: undefined,
}

const member = (state = defaultMember, { type, payload }) => {
  switch (type) {
    case UPDATE_DETAIL_SUCCESS:
      return { ...state, ...payload.member }

    case RESET_ALL:
      return defaultMember

    case RESET_POSITION_DETAIL_SUCCESS:
      return { ...defaultMember, ...payload }

    default:
      return state
  }
}

const defaultCounts = {}

const totalCounts = (state = defaultCounts, { type, payload }) => {
  switch (type) {
    case UPDATE_CANDIDATE_COUNT:
      return { ...state, ...payload }

    case RESET_ALL:
      return defaultCounts

    default:
      return state
  }
}

export default combineReducers({
  utils,
  member,
  totalCounts,
})
